export default __webpack_public_path__ + "locales/nl/FilesSettings.json?hash=4947eae1c79147ba17c967c7135e7e3f";